/** Major OJK-licensed commercial banks used for client margin accounts (not exhaustive). */
export const INDONESIA_BANKS = [
  'BCA',
  'Bank Mandiri',
  'BNI',
  'BRI',
  'Bank Syariah Indonesia (BSI)',
  'CIMB Niaga',
  'Permata Bank',
  'Bank Danamon',
  'Panin Bank',
  'Bank Mega',
  'BTN',
  'OCBC NISP',
  'Maybank Indonesia',
  'Bank BJB',
  'Bank Muamalat',
  'Bank Sinarmas',
  'Bank Mayapada',
  'UOB Indonesia',
  'DBS Indonesia',
  'HSBC Indonesia',
  'Standard Chartered Indonesia',
  'Bank Jago',
  'SeaBank Indonesia',
  'Bank BTPN',
  'Bank Bukopin',
  'Bank Mestika',
  'Bank Victoria',
  'Bank BPD Bali',
  'Bank BPD DIY',
  'Bank BPD Jateng',
  'Bank BPD Jatim',
  'Bank BPD Sumut',
  'Bank BPD Sumsel Babel',
  'Bank BPD Kalbar',
  'Bank BPD Kaltimtara',
  'Bank BPD Sulselbar',
] as const
